// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1YgYN","content":"LayoutSettings_content__1KiWD"};